import { render } from "./LocationContent.vue?vue&type=template&id=56839541&scoped=true&ts=true"
import script from "./LocationContent.vue?vue&type=script&lang=ts"
export * from "./LocationContent.vue?vue&type=script&lang=ts"

import "./LocationContent.vue?vue&type=style&index=0&id=56839541&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56839541"]])

export default __exports__